
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/penly-panelet",
      function () {
        return require("private-next-pages/penly-panelet/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/penly-panelet"])
      });
    }
  